import styled from "@emotion/styled";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MDSLoadingArrowsSize } from "./loading-arrows.types";

interface StyledLoadingArrowsProps {
  size: MDSLoadingArrowsSize;
}

const getSizeStyles = (size: MDSLoadingArrowsSize) => {
  switch (size) {
    case MDSLoadingArrowsSize.Small:
      return {
        width: "32px",
        height: "32px",
      };
    case MDSLoadingArrowsSize.Smedium:
      return {
        width: "38px",
        height: "38px",
      };
    case MDSLoadingArrowsSize.Medium:
      return {
        width: "48px",
        height: "48px",
      };
    case MDSLoadingArrowsSize.Large:
      return {
        width: "64px",
        height: "64px",
      };
    default:
      return {
        width: "48px",
        height: "48px",
      };
  }
};

export const StyledLoadingArrowsContainer = styled.div<StyledLoadingArrowsProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: -6px; /* lines up visually */
  ${({ size }) => getSizeStyles(size)}
`;

export const StyledDotLottieReact = styled(DotLottieReact)`
  width: 100%;
  height: 100%;
`;
